import { render, staticRenderFns } from "./SPRStatusIndicator.vue?vue&type=template&id=279a601c"
import script from "./SPRStatusIndicator.vue?vue&type=script&lang=js"
export * from "./SPRStatusIndicator.vue?vue&type=script&lang=js"
import style0 from "./SPRStatusIndicator.vue?vue&type=style&index=0&id=279a601c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports